<template>
  <div class="box" @click.stop>
    <div class="title">点评</div>
    <div class="input">
      <van-field
        v-model="message"
        maxlength="2000"
        rows="6"
        autosize
        type="textarea"
        placeholder="请输入点评内容"
        show-word-limit
      />
    </div>
    <div class="btn-list">
      <div class="btn-item save-btn" @click="bindSave">保存</div>
      <div class="btn-item submit-btn" @click="bindSubmit">提交</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dietData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      message: '',
      limitText: 20 //最少文字限制
    }
  },
  watch: {
    message() {
      this.dietData.extra_meal_card_comment = this.message
    }
  },
  created() {
    this.message = this.dietData.extra_meal_card_comment || ''
  },
  methods: {
    bindSave() {
      let words = this.dietData.extra_meal_card_comment
      if (!words || words.length < this.limitText) {
        this.$toast('点评文字不能少于' + this.limitText)
        return
      }
      this.$emit('save')
    },
    bindSubmit() {
      let words = this.dietData.extra_meal_card_comment
      if (!words || words.length < this.limitText) {
        this.$toast('点评文字不能少于' + this.limitText)
        return
      }
      this.$emit('release')
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  background: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px;
  box-sizing: border-box;

  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 10px;
  }

  .input {
    border: 1px solid #e1e1e1;
    border-radius: 8px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .btn-item {
      border: 1px solid #f1f1f1;
      box-sizing: border-box;
      width: 140px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      background: #ffffff;
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }

    .submit-btn {
      border: 1px solid #6236ff;
      background: #6236ff;
      color: #ffffff;
    }
  }
}
</style>
